import { render, staticRenderFns } from "./DialogOrInline.vue?vue&type=template&id=c6d1a46a&scoped=true&"
import script from "./DialogOrInline.vue?vue&type=script&lang=js&"
export * from "./DialogOrInline.vue?vue&type=script&lang=js&"
import style0 from "./DialogOrInline.vue?vue&type=style&index=0&id=c6d1a46a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6d1a46a",
  null
  
)

export default component.exports